import React from 'react'
import { prop } from 'ramda'
import { generatePath, useNavigate } from 'react-router-dom'
import { useSnackbar } from 'storfox-snackbar'

import { DashboardLayout } from '~/components/Layouts'
import * as NAV from '~/constants/nav-titles'
import { INTEGRATION_TABS } from '~/constants/tabs'
import * as ROUTES from '~/constants/routes'
import useMessages from '~/hooks/useMessages'

import { useZidCreate } from '../../hooks'
import ZidAppCreateForm from '../../components/Zid/ZidAppCreateForm'

function ZidApplicationContainer () {
  const messages = useMessages()
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  const integrationCreate = useZidCreate()

  const handleSubmit = formValues =>
    integrationCreate
      .create(formValues)
      .then(({ result }) => {
        const guid = prop('guid', result)
        const type = 'zid'
        const params = { guid, type, tab: INTEGRATION_TABS.GENERAL }
        const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, params)
        navigate(detailPath)
      })
      .then(() => snackbar({ message: messages.CREATE_SUCCESS }))

  const title = 'New Zid integration'

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      title={title}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <ZidAppCreateForm
        initialValues={{ type: 'zid_app', matchSku: false }}
        onSubmit={handleSubmit}
      />
    </DashboardLayout>
  )
}

export default ZidApplicationContainer
